import { FormFieldType } from "../../../../../../model/formFields";

const paths: Record<FormFieldType, JSX.Element> = {
  SHORT_TEXT: <path d="M4 7V5h16v2M9 19h6M12 5v14" />,
  LONG_TEXT: <path d="M4 6h16M4 10h16M4 14h16M4 18h10" />,
  EMAIL: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m3 7 9 6 9-6" />
    </>
  ),
  PHONE: (
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
  ),
  NUMBER: <path d="M4 9h16M4 15h16M10 3 8 21M16 3l-2 18" />,
  DATE: (
    <>
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <path d="M16 2v4M8 2v4M3 10h18" />
    </>
  ),
  DOCUMENT: (
    <>
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <circle cx="8" cy="12" r="2" />
      <path d="M13 10h5M13 14h3" />
    </>
  ),
  SELECT: (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="m9 11 3 3 3-3" />
    </>
  ),
  CHECKBOX: (
    <>
      <rect x="3" y="3" width="18" height="18" rx="4" />
      <path d="m8 12 3 3 5-6" />
    </>
  ),
};

type Props = {
  type: FormFieldType;
  size?: number;
  color?: string;
};

/** Icon of a form field type, drawn as outlined strokes like the section icons. */
export const FieldTypeIcon = ({ type, size = 20, color = "currentColor" }: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true">
    {paths[type]}
  </svg>
);
